import React from "react";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import { Props } from "./types";
import styles from "./styles.scss";

function Path({ path, project, onNavigate, className = "" }: Props) {
  const push = useNavigate();

  return (
    <ul className={classNames(className, styles.path)}>
      {path.map(({ uuid, name }, index) => (
        <li
          key={uuid}
          className={classNames(styles.item, { [styles.project]: index === 0 })}
          onClick={() =>
            !!onNavigate
              ? onNavigate(project.uuid, uuid)
              : push(`/projects/${project.uuid}/documents/folders/${uuid}`)
          }
        >
          <p>{index === 0 ? project.name : name}</p>
        </li>
      ))}
    </ul>
  );
}

export { Path };
